import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`我是黃冠融, 大家都叫我 Kevin，目前在 Octalysis Prime 擔任 SRE。我擁有五年軟體開發經驗、四年的專案管理以及二年的遊戲化經驗。`}</p>
    <p>{`相關演講經歷:`}</p>
    <ul>
      <li parentName="ul">{`DDD in Smart Contract`}</li>
      <li parentName="ul">{`Introduce DevOps practices into legacy product`}</li>
      <li parentName="ul">{`Bridging the communication gap between Dev and Ops`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      